/* istanbul ignore file */
import React from 'react';
import { Show } from 'framework/show';
import { ShowSection, SectionRow, BigSectionRow, FieldListLayout } from 'framework/ui/layout';
import { EmployeeLinkField } from 'domain/shared/employee';
import useVacancyService, {
  COMPETENCY_LEVEL,
  VACANCY_DUE_DATE,
  VACANCY_POSITIONS,
  VACANCY_STATUSES,
  VACANCY_TYPES,
} from 'domain/recruiting/vacancy/shared/vacancyService';
import { CommaListField, EnumField, HtmlField, TextField } from 'framework/ui/field';
import { useVacancyId } from 'domain/recruiting/vacancy/vacancyRoute';
import ExpectedCompensationField from '../shared/field/ExpectedCompensationField';
import NameDescriptionField from 'domain/recruiting/vacancy/shared/field/NameDescriptionField';
import VacancyDetailsField from 'domain/recruiting/vacancy/shared/field/VacancyDetailsField';
import VacancyPublicationListLinkField from 'domain/recruiting/vacancy/publication/shared/field/VacancyPublicationListLinkField';
import ShowVacancyPageLayout from 'domain/recruiting/vacancy/Show/ShowVacancyPageLayout';

const ViewVacancy = () => {
  const id = useVacancyId()!;
  const { getById } = useVacancyService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowVacancyPageLayout>
        <ShowSection title="Vacancy Information">
          <SectionRow>
            <TextField source="alias" label="Vacancy ID" />
            <TextField source="name" label="Position" />
            <EnumField options={COMPETENCY_LEVEL} source="competencyLevel" label="Competency level" />
            <EnumField source="status" label="Status" options={VACANCY_STATUSES} />
          </SectionRow>
          <SectionRow>
            <EmployeeLinkField source="managerAlias" nameSource="managerName" label="Manager" />
            <EmployeeLinkField source="sourcerAlias" nameSource="sourcerName" label="Sourcer" />
            <EmployeeLinkField source="requestedById" nameSource="requestedByName" label="Requested by" />
            <EnumField source="dueDate" label="Due date" options={VACANCY_DUE_DATE} />
            <EnumField source="type" options={VACANCY_TYPES} />
            <EnumField
              isVisible={(data: any) => !!data.openPositions}
              source="openPositions"
              options={VACANCY_POSITIONS}
            />
          </SectionRow>
        </ShowSection>
        <ShowSection title="Vacancy details">
          <FieldListLayout source="vacancyDetails" hasSeparator>
            <VacancyDetailsField />
          </FieldListLayout>
        </ShowSection>
        <ShowSection title="Expected Compensation">
          <ExpectedCompensationField source="expectedCompensation" />
        </ShowSection>
        <ShowSection title="Project description">
          <BigSectionRow>
            <div className="column-field__wrapper">
              <HtmlField source="description.projectText" />
            </div>
          </BigSectionRow>
        </ShowSection>
        <ShowSection title="Responsibilities">
          <BigSectionRow>
            <FieldListLayout source="description.responsibilities">
              <NameDescriptionField />
            </FieldListLayout>
          </BigSectionRow>
        </ShowSection>
        <ShowSection title="Mandatory requirements">
          <BigSectionRow>
            <FieldListLayout source="description.requirements">
              <NameDescriptionField />
            </FieldListLayout>
            <CommaListField source="description.mandatorySkills" />
            <TextField source="minExperience" label="Minimum experience (years)" />
          </BigSectionRow>
        </ShowSection>
        <ShowSection title="Optional requirements">
          <BigSectionRow>
            <FieldListLayout source="description.optionalRequirements">
              <NameDescriptionField />
            </FieldListLayout>
            <CommaListField source="description.optionalSkills" />
          </BigSectionRow>
        </ShowSection>
        <ShowSection title="Personality">
          <BigSectionRow>
            <FieldListLayout source="description.personality">
              <NameDescriptionField />
            </FieldListLayout>
          </BigSectionRow>
        </ShowSection>
        <ShowSection title="Publications">
          <FieldListLayout source="publications">
            <VacancyPublicationListLinkField />
          </FieldListLayout>
        </ShowSection>
      </ShowVacancyPageLayout>
    </Show>
  );
};

export default ViewVacancy;
